import React from 'react'
import Heading from 'src/components/Heading';
import Button from 'src/components/Button';
import RichText from 'src/utils/RichText';
import FluidImage from 'src/utils/FluidImage'

const Panel = ({active, id, description, target, image}) => {

    return (
        <div className={`overflow-hidden ${id === active ? 'visible h-auto' : 'invisible !h-0'}`}> 
            <div className={`grid lg:grid-cols-2 grid-cols-1 lg:gap-20 gap-8 duration-500 ${id === active ? 'opacity-100' : 'opacity-0'}`}>
                <FluidImage image={image} className="rounded-md shadow-lg mb-4"/>
                <div className="flex flex-col justify-center lg:items-start items-center">
                    <Heading size="h3" className="capitalize font-semibold text-darkblue">{id}</Heading>
                    <div className="prose text-darkblue-700 lg:text-left text-center">
                        <RichText>{description}</RichText>
                    </div>
                    <Button 
                        to={target?.cached_url} 
                        before={`Discover ${id}`}
                        className="bg-brightgreen hover:bg-brightgreenhover mt-8 mr-3 before:content-[attr(before)] capitalize before:capitalize"
                    >
                        {target?.cached_url && `Discover ${id}`}
                    </Button>
                </div>
            </div>    
        </div>
    )
}

export default Panel
